import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import { TeamRole } from '../../store/Models/UserContext';
import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import Layout from "../Layout";

type NewsAbstractionProps =
    RouteComponentProps &
    ToxnotComponentProperties;

export abstract class NewsAbstraction extends ToxnotSignInRequiredComponent<NewsAbstractionProps> {
    protected getDisallowedRoles(): TeamRole[] {
        return []; // no roles disallowed
    }

    protected abstract renderNewsContent(): JSX.Element;

    protected renderConcreteComponent(): JSX.Element | null {
        const userContext = this.getUserContext();

        if (userContext == null) {
            return <div></div>;
        }

        if (!userContext.userCapabilities.newsEnabled) {
            return(
                <Layout>
                    <div className="tn-section text-center">
                        <p>{this.localizeString("You don't have access the view News Pages")}</p>
                    </div>
                </Layout>
            )
        }

        return (
            <Layout>
                <div className="tn-section">
                    {this.renderNewsContent()}
                </div>
            </Layout>
        );
    }

    protected getUserObject() {
        const userContext = this.getUserContext();
        
        return {
            userName: userContext?.emailAddress,
            email: userContext?.emailAddress,
            token: ""
        };
    }
}

export function withCommonNews<P extends NewsAbstractionProps>(
    WrappedComponent: React.ComponentType<P>
) {
    return connect(
        (state: ApplicationState) => ({ appServices: state.appServices })
    )(WrappedComponent as any);
}